<template>

  <SideBarAsideUser/>

  <div class="content pd-0" style="border: 1px solid #ccc;">
    <div class="content-header">
      <div class="content-search">
        <i data-feather="search"></i>
        <input type="search" class="form-control" placeholder="Search...">
      </div>
      <nav class="nav">
        <a href="" class="nav-link"><i data-feather="help-circle"></i></a>
        <a href="" class="nav-link"><i data-feather="grid"></i></a>
        <a href="" class="nav-link"><i data-feather="align-left"></i></a>
      </nav>
    </div><!-- content-header -->

    <div class="content-body">
      <div class="container pd-x-0">


        <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
          <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page"> User Corner</li>
              </ol>
            </nav>
            <h4 class="mg-b-0 tx-spacing--1"> Watch Video </h4>
          </div>
          <div class="d-none d-md-block">
            <button class="btn btn-sm pd-x-15 btn-white btn-uppercase"><i data-feather="mail" class="wd-10 mg-r-5"></i>
              Email
            </button>
            <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"><i data-feather="printer"
                                                                                 class="wd-10 mg-r-5"></i> Print
            </button>
            <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><i data-feather="file"
                                                                                   class="wd-10 mg-r-5"></i> Generate
              Report
            </button>
          </div>
        </div>


        <div class="" style="margin-top: -10px;">
          <!-- ═══ TABS ═══ -->
          <ul class="nav nav-videos mg-t-15 mg-b-30" id="vidTabs" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" data-toggle="tab" href="#tab-sug" role="tab">Suggestions</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#tab-pop" role="tab">Popular</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#tab-mine" role="tab">My Videos</a>
            </li>
          </ul>

          <!-- ═══ TAB CONTENT ═══ -->
          <div class="tab-content">

            <!-- ──────────────────────────────────────────
                 SUGGESTIONS TAB
            ─────────────────────────────────────────── -->
            <div class="tab-pane fade show active" id="tab-sug" role="tabpanel">

              <!-- Suggestion carousel -->

              <!-- Suggestion carousel -->
              <div class="carousel-outer mg-b-50">

                <div class="carousel-track" ref="carouselTrack" :style="carouselStyle">

                  <!-- Dynamic Suggestion Cards -->
                  <div v-for="video in suggestionVideos" :key="video.id">
                    <div class="card bd sug-card">
                      <a class="vid-thumb vid-thumb-card" :href="`/watch/${video.id}`">
                        <img :src="video.thumbnailUrl" :alt="video.title">
                        <div class="vid-play">
                          <div class="vid-play-btn"><i class="fas fa-play" style="margin-left:2px;"></i></div>
                        </div>
                        <span class="vid-dur">{{ video.duration }}</span>
                      </a>
                      <a class="sug-body" :href="`/watch/${video.id}`">
                        <p class="sug-title">{{ video.title }}</p>
                        <p class="tx-12 tx-color-03 mg-b-2">{{ video.channelName }}</p>
                        <p class="tx-11 tx-color-03 mg-b-0">{{ video.uploadedAgo }} · {{ video.views }} views</p>
                      </a>
                    </div>

                  </div>
                </div><!-- /carousel-track -->

                <!-- Vue-Controlled Arrow -->
                <button class="carousel-arrow"
                        aria-label="Toggle carousel"
                        @click="toggleCarousel">

                  <i :class="arrowIconClass"></i>

                </button>

              </div><!-- /carousel-outer -->



              <!-- "Your videos" section label -->
              <div class="d-flex align-items-center justify-content-between mg-b-15 section-hd">
                <h6 class="tx-15 tx-semibold tx-color-01 mg-b-0">Your videos</h6>
                <a href="#" class="tx-13 tx-primary">See all</a>
              </div>


              <!-- ══ List rows ══ -->


              <div class="vid-row" v-for="video in userVideos" :key="video.id">
                <a href="#" class="vid-thumb vid-thumb-list flex-shrink-0">
                  <img :src="video.thumbnailUrl" :alt="video.title">
                  <div class="vid-play">
                    <div class="vid-play-btn">
                      <i class="fas fa-play" style="margin-left:2px;"></i>
                    </div>
                  </div>
                  <span class="vid-dur">{{ video.duration }}</span>
                </a>

                <div class="vid-row-body">
                  <div>
                    <div class="d-flex align-items-start justify-content-between">
                      <h6 class="vid-row-title">{{ video.title }}</h6>

                      <div class="dropdown flex-shrink-0 mg-l-10">
                        <a href="#" class="tx-color-04 tx-18" data-toggle="dropdown">
                          <i class="fas fa-ellipsis-h"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a class="dropdown-item" href="#">Save</a>
                          <a class="dropdown-item" href="#">Share</a>
                          <a class="dropdown-item text-danger" href="#">Report</a>
                        </div>
                      </div>
                    </div>

                    <p class="vid-row-desc">{{ video.description }}</p>
                  </div>

                  <div class="d-flex align-items-end justify-content-between vid-row-footer">
                    <div>
                      <a href="#" class="vid-row-channel">{{ video.channelName }}</a>
                      <span class="tx-12 tx-color-03">{{ video.uploadedAgo }} · {{ video.views }} views</span>
                    </div>
                    <button class="btn btn-outline-secondary btn-sm flex-shrink-0 tx-12 vid-row-footer-btn">
                      Add favorites
                    </button>
                  </div>
                </div>
              </div>


            </div><!-- /suggestions tab -->

            <!-- ── Popular tab (placeholder) ── -->
            <div class="tab-pane fade" id="tab-pop" role="tabpanel">
              <div class="d-flex align-items-center justify-content-center pd-y-60">
                <div class="text-center">
                  <i class="fas fa-fire tx-40 tx-warning mg-b-15 d-block"></i>
                  <h6 class="tx-15 tx-semibold tx-color-01">Popular Videos</h6>
                  <p class="tx-13 tx-color-03 mg-b-0">Trending content will appear here.</p>
                </div>
              </div>
            </div>

            <!-- ── My Videos tab (placeholder) ── -->
            <div class="tab-pane fade" id="tab-mine" role="tabpanel">
              <div class="d-flex align-items-center justify-content-center pd-y-60">
                <div class="text-center">
                  <i class="fas fa-video tx-40 tx-primary mg-b-15 d-block"></i>
                  <h6 class="tx-15 tx-semibold tx-color-01">Your Uploaded Videos</h6>
                  <p class="tx-13 tx-color-03">Videos you've uploaded will appear here.</p>
                  <a href="#" class="btn btn-primary btn-sm"><i class="fas fa-plus mg-r-5"></i>Upload Video</a>
                </div>
              </div>
            </div>

          </div><!-- /tab-content -->

        </div><!-- /container-xl -->


      </div><!-- container -->
    </div>

  </div>


</template>


<script>
import visualizationMixin from "@/mixins/visualization-script";
import footerScriptMixin from "@/mixins/footer-script";
import serviceMixin from "@/mixins/contact-service";
import SideBarAsideUser from "../components/SideBarAsideUser.vue";
// import axios from "axios";  // enable later

export default {
  name: 'VideoList',
  components: {SideBarAsideUser},
  mixins: [visualizationMixin, footerScriptMixin, serviceMixin],

  data() {
    return {
      offset: 0,
      isShifted: false,
      columnWidth: 0,
      suggestionVideos: [
        {
          id: 1,
          title: "Amazing House Construction From Foundation To Last Detail",
          thumbnailUrl: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=640&h=360&auto=format&fit=crop&q=80",
          duration: "12:21",
          channelName: "Jesse Steeve",
          views: "156.9K",
          uploadedAgo: "27 weeks ago",
          description: "Full house construction documentary."
        },
        {
          id: 2,
          title: "Great Drone Jet Testing Range Flat Model Show With Advance",
          thumbnailUrl: "https://images.unsplash.com/photo-1561144257-e32e8506e0b4?w=640&h=360&auto=format&fit=crop&q=80",
          duration: "09:15",
          channelName: "John Michael",
          views: "98.1K",
          uploadedAgo: "12 weeks ago",
          description: "Drone testing and model showcase."
        },
        {
          id: 3,
          title: "Exploring Latest An Abandoned Water Park In China City",
          thumbnailUrl: "https://images.unsplash.com/photo-1533106958148-daaeab8b83fe?w=640&h=360&auto=format&fit=crop&q=80",
          duration: "18:44",
          channelName: "Monroe Parker",
          views: "202K",
          uploadedAgo: "5 months ago",
          description: "Urban exploration documentary."
        },
        {
          id: 4,
          title: "Exploring Latest An Abandoned Water Park In China City",
          thumbnailUrl: "https://images.unsplash.com/photo-1533106958148-daaeab8b83fe?w=640&h=360&auto=format&fit=crop&q=80",
          duration: "18:44",
          channelName: "Monroe Parker",
          views: "202K",
          uploadedAgo: "5 months ago",
          description: "Urban exploration documentary."
        }

      ],

      // ================================
      // USER VIDEO LIST (Rows)
      // ================================
      userVideos: [
        {
          id: 101,
          title: "Great Drone Jet Testing Range Flat Model Show With Advance",
          thumbnailUrl: "https://images.unsplash.com/photo-1561144257-e32e8506e0b4?w=572&h=324&auto=format&fit=crop&q=80",
          duration: "12:21",
          channelName: "John Michael",
          views: "156.9K",
          uploadedAgo: "27 weeks ago",
          description: "consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,"
        },
        {
          id: 102,
          title: "Exploring Latest An Abandoned Water Park In China City",
          thumbnailUrl: "https://images.unsplash.com/photo-1533106958148-daaeab8b83fe?w=572&h=324&auto=format&fit=crop&q=80",
          duration: "12:21",
          channelName: "Monroe Parker",
          views: "156.9K",
          uploadedAgo: "27 weeks ago",
          description: "consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,"
        },
        {
          id: 103,
          title: "Cheese Cake Eggless Without Oven Hida Mari Cooking",
          thumbnailUrl: "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=572&h=324&auto=format&fit=crop&q=80",
          duration: "12:21",
          channelName: "Martin Gray",
          views: "156.9K",
          uploadedAgo: "27 weeks ago",
          description: "consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,"
        }
      ]

    }
  },

  created() {
    this.footerScript();
    this.asideBarScript();

    // ====================================
    // Future: Load from Spring Boot API
    // ====================================
    /*
    axios.get('/api/videos/suggestions')
      .then(response => {
        this.suggestionVideos = response.data;
      });

    axios.get('/api/videos/user')
      .then(response => {
        this.userVideos = response.data;
      });
    */
  },
  computed: {
    carouselStyle() {
      return {
        transform: `translateX(-${this.offset}px)`
      };
    },
    arrowIconClass() {
      return this.isShifted
          ? 'fas fa-chevron-left'
          : 'fas fa-chevron-right';
    }
  },

  mounted() {
    this.calculateColumnWidth();
    window.addEventListener('resize', this.calculateColumnWidth);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.calculateColumnWidth);
  },

  methods: {
    calculateColumnWidth() {
      const track = this.$refs.carouselTrack;
      if (!track) return;
      const parentWidth = track.parentElement.offsetWidth;
      // 4 columns layout (desktop)
      this.columnWidth = parentWidth / 4;
    },

    toggleCarousel() {
      if (!this.isShifted) {
        this.offset = this.columnWidth;
        this.isShifted = true;
      } else {
        this.offset = 0;
        this.isShifted = false;
      }
    }

  }
}
</script>

<style>
@import 'https://app.wcicambridge.org/cdn/assets/css/dashforge.css';
@import '../../assets/lib/remixicon/fonts/remixicon.css';
@import '../../assets/lib/select2/css/select2.min.css';

/*
   * NEW CSS — only for things Bootstrap 4 + DashForge cannot express natively.
   * All colour tokens (tx-color-01/03/04, tx-primary), spacing (mg-*, pd-*),
   * card/btn/dropdown/tab come straight from DashForge or Bootstrap 4.
   *
   * Responsive breakpoints mirror Bootstrap 4:
   *   xs  <576px   · sm 576–767px   · md 768–991px   · lg ≥992px (default)
   */

body {
  background-color: #f0f2f5;
}

/* ════════════════════════════════════════════
   TABS — clean underline style
════════════════════════════════════════════ */
.nav-videos {
  border-bottom: 1px solid #cdd4e0;
  flex-wrap: nowrap;
  overflow-x: auto; /* allows horizontal scroll on tiny screens */
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
}

.nav-videos::-webkit-scrollbar {
  display: none;
}

.nav-videos .nav-link {
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  color: #596882;
  font-size: 14px;
  font-weight: 400;
  padding: 10px 0;
  margin-right: 28px;
  background: transparent;
  white-space: nowrap;
  transition: color .15s;
}

.nav-videos .nav-link:hover {
  color: #1b2e4b;
  background: transparent;
}

.nav-videos .nav-link.active {
  color: #1b2e4b;
  font-weight: 600;
  border-bottom-color: #1b2e4b;
  background: transparent;
}

/* ════════════════════════════════════════════
   CAROUSEL — desktop default: 4-column grid
════════════════════════════════════════════ */
.carousel-outer {
  position: relative;
}

.carousel-track {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  overflow: hidden;
  transition: transform .35s ease;
}

/* Arrow button */
.carousel-arrow {
  position: absolute;
  right: -15px;
  top: 80px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #cdd4e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .10);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #596882;
  font-size: 10px;
  z-index: 10;
  transition: box-shadow .15s, color .15s;
}

.carousel-arrow:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, .16);
  color: #1b2e4b;
}

/* ════════════════════════════════════════════
   THUMBNAILS — shared base styles
════════════════════════════════════════════ */
.vid-thumb {
  position: relative;
  display: block;
  overflow: hidden;
  background: #000;
  line-height: 0;
}

.vid-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: opacity .2s;
}

.vid-thumb:hover img {
  opacity: .86;
}

/* Carousel card thumbnail */
.vid-thumb-card {
  border-radius: 5px 5px 0 0;
  height: 164px;
}

/* List row thumbnail — desktop fixed size */
.vid-thumb-list {
  border-radius: 5px 0 0 5px;
  width: 285px;
  min-width: 285px;
  height: 162px;
}

/* ════════════════════════════════════════════
   PLAY OVERLAY + DURATION BADGE
════════════════════════════════════════════ */
.vid-play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.vid-play-btn {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(0, 0, 0, .52);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  flex-shrink: 0;
}

.vid-dur {
  position: absolute;
  bottom: 7px;
  right: 8px;
  background: rgba(0, 0, 0, .70);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .2px;
  padding: 1px 6px;
  border-radius: 3px;
  pointer-events: none;
}

/* ════════════════════════════════════════════
   SUGGESTION CARDS
════════════════════════════════════════════ */
.sug-body {
  padding: 11px 12px 13px;
}

.sug-title {
  font-size: 13px;
  font-weight: 600;
  color: #1b2e4b;
  line-height: 1.45;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.sug-card {
  transition: box-shadow .2s, transform .15s;
  cursor: pointer;
}

.sug-card:hover {
  box-shadow: 0 5px 18px rgba(0, 0, 0, .10) !important;
  transform: translateY(-2px);
}

/* ════════════════════════════════════════════
   LIST ROWS — desktop default (horizontal)
════════════════════════════════════════════ */
.vid-row {
  display: flex;
  flex-direction: row;
  background: #fff;
  border: 1px solid #e3e7ed;
  border-radius: 6px;
  overflow: hidden;
}

.vid-row + .vid-row {
  margin-top: 12px;
}

.vid-row-body {
  flex: 1;
  min-width: 0;
  padding: 16px 18px 14px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.vid-row-title {
  font-size: 15px;
  font-weight: 600;
  color: #1b2e4b;
  line-height: 1.4;
  margin-bottom: 7px;
}

.vid-row-desc {
  font-size: 13px;
  color: #97a3b9;
  line-height: 1.6;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.vid-row-channel {
  font-size: 13px;
  font-weight: 500;
  color: #0168fa;
  display: block;
  margin-bottom: 2px;
  text-decoration: none;
}

.vid-row-channel:hover {
  text-decoration: underline;
}

/* ════════════════════════════════════════════
   RESPONSIVE — md  768–991px  (tablet)
   Carousel: 2 columns  |  List: narrower thumb
════════════════════════════════════════════ */
@media (max-width: 991px) {

  /* 2-column carousel */
  .carousel-track {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    /* On tablet the track still hides extras — JS still manages offset */
  }

  /* Arrow stays but repositions for 2-col height */
  .carousel-arrow {
    top: 72px;
  }

  /* Narrower list thumbnail */
  .vid-thumb-list {
    width: 220px;
    min-width: 220px;
    height: 148px;
  }

  /* Tighten list body padding */
  .vid-row-body {
    padding: 14px 16px 12px 16px;
  }

  .vid-row-title {
    font-size: 14px;
  }
}

/* ════════════════════════════════════════════
   RESPONSIVE — sm  576–767px  (large phone)
   Carousel: 2-col horizontal scroll (no JS arrow)
   List rows: stacked (thumb full-width on top)
════════════════════════════════════════════ */
@media (max-width: 767px) {

  /* Page padding tighter */
  .container-xl {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  /* ── Carousel becomes a horizontal scroll strip ── */
  .carousel-outer {
    overflow: hidden;
  }

  /* clip left/right */
  .carousel-track {
    grid-template-columns: repeat(5, calc(50% - 7px)); /* 2 visible at once */
    gap: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    scroll-snap-type: x mandatory;
    /* Reset JS transform — native scroll takes over */
    transform: none !important;
    transition: none;
  }

  .carousel-track::-webkit-scrollbar {
    display: none;
  }

  .carousel-track > div {
    scroll-snap-align: start;
  }

  /* Hide JS arrow — native swipe replaces it */
  .carousel-arrow {
    display: none !important;
  }

  /* Card thumbnail height slightly shorter */
  .vid-thumb-card {
    height: 140px;
  }

  /* ── List rows: stack vertically ── */
  .vid-row {
    flex-direction: column;
  }

  .vid-thumb-list {
    width: 100%;
    min-width: 0;
    height: 200px; /* nice 16:9-ish ratio at phone width */
    border-radius: 5px 5px 0 0; /* top corners rounded, bottom flat */
  }

  .vid-row-body {
    padding: 14px 14px 12px;
  }

  .vid-row-title {
    font-size: 14px;
    margin-bottom: 5px;
  }

  /* Footer row: stack channel/meta above button */
  .vid-row-footer {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 10px;
  }
}

/* ════════════════════════════════════════════
   RESPONSIVE — xs  <576px  (small phone)
   Carousel: 1 card visible (full-width scroll)
   List: stacked, compact
════════════════════════════════════════════ */
@media (max-width: 575px) {

  /* ── 1-card-visible scroll carousel ── */
  .carousel-track {
    grid-template-columns: repeat(5, calc(100% - 20px));
    gap: 10px;
  }

  .vid-thumb-card {
    height: 190px;
  }

  /* portrait phone gets taller thumb */
  /* ── List thumb fills full width ── */
  .vid-thumb-list {
    height: 56vw;
  }

  /* ~16:9 at most phone widths */
  .vid-row-body {
    padding: 12px;
  }

  .vid-row-title {
    font-size: 14px;
  }

  .vid-row-desc {
    -webkit-line-clamp: 3;
  }

  /* show a bit more on small screens */
  /* "Add favorites" button full-width on tiny screens */
  .vid-row-footer-btn {
    width: 100% !important;
  }

  /* Section header tighter */
  .section-hd {
    margin-bottom: 10px !important;
  }
}

/* ════════════════════════════════════════════
   Touch-device: disable hover lift (avoids
   stuck transform after tap on iOS)
════════════════════════════════════════════ */
@media (hover: none) {
  .sug-card:hover {
    box-shadow: none !important;
    transform: none !important;
  }

  .vid-thumb:hover img {
    opacity: 1;
  }
}
</style>

